import { render } from "./TemporaryCandidate.root.vue?vue&type=template&id=741c63ae"
import script from "./TemporaryCandidate.root.vue?vue&type=script&lang=js"
export * from "./TemporaryCandidate.root.vue?vue&type=script&lang=js"

import "./TemporaryCandidate.root.vue?vue&type=style&index=0&id=741c63ae&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar,QBtn,QToolbarTitle,QTabs,QRouteTab,QPageContainer,QPage,QFooter,QBanner});
